export default function useAccessibilityOptions() {
	return [
		{ key: "00", value: "00", text: "Accessibility summary" },
		{ key: "01", value: "01", text: "LIA Compliance Scheme" },
		{ key: "02", value: "02", text: "EPUB Accessibility Specification 1.0 A" },
		{ key: "03", value: "03", text: "EPUB Accessibility Specification 1.0 AA" },
		{ key: "04", value: "04", text: "Epub Accessibility Specification 1.1" },
		{ key: "05", value: "05", text: "PDF/UA-1" },
		{ key: "06", value: "06", text: "PDF/UA-2" },
		{ key: "08", value: "08", text: "Unknown accessibility" },
		{ key: "09", value: "09", text: "Inaccessible, or known limited accessibility" },
		{ key: "10", value: "10", text: "No reading system accessibility options actively disabled (except)" },
		{ key: "11", value: "11", text: "Table of contents navigation" },
		{ key: "12", value: "12", text: "Index navigation" },
		{ key: "13", value: "13", text: "Single logical reading order" },
		{ key: "14", value: "14", text: "Short alternative textual descriptions" },
		{ key: "15", value: "15", text: "Full alternative textual descriptions" },
		{ key: "16", value: "16", text: "Visualised data also available as non-graphical data" },
		{ key: "17", value: "17", text: "Accessible math content as MathML" },
		{ key: "18", value: "18", text: "Accessible chemistry content as ChemML" },
		{ key: "19", value: "19", text: "Print-equivalent page numbering" },
		{ key: "20", value: "20", text: "Synchronised pre-recorded audio" },
		{ key: "21", value: "21", text: "Text-to-speech hinting provided" },
		{ key: "22", value: "22", text: "Language tagging provided" },
		{ key: "24", value: "24", text: "Dyslexia readability" },
		{ key: "25", value: "25", text: "Use of color is not sole means of conveying information" },
		{ key: "26", value: "26", text: "Use of high contrast between text and background color" },
		{ key: "27", value: "27", text: "Use of high contrast between foreground and background audio" },
		{ key: "28", value: "28", text: "Full alternative audio descriptions" },
		{ key: "29", value: "29", text: "Next / Previous structural navigation" },
		{ key: "30", value: "30", text: "ARIA roles provided" },
		{ key: "31", value: "31", text: "Accessible controls provided" },
		{ key: "32", value: "32", text: "Landmark navigation" },
		{ key: "34", value: "34", text: "Accessible chemistry content (as MathML)" },
		{ key: "35", value: "35", text: "Accessible math content (as LaTeX)" },
		{ key: "36", value: "36", text: "Appearance of all textual content can be modified" },
		{ key: "37", value: "37", text: "Use of ultra-high contrast between text foreground and background" },
		{ key: "38", value: "38", text: "Unusual words or abbreviations explained" },
		{ key: "39", value: "39", text: "Supplementary material to an audiobook is accessible" },
		{ key: "40", value: "40", text: "Link purposes clear" },
		{ key: "41", value: "41", text: "Page list navigation" },
		{ key: "51", value: "51", text: "All non-decorative content supports reading via pre-recorded audio" },
		{ key: "52", value: "52", text: "All non-decorative content supports reading without sight" },
		{ key: "53", value: "53", text: "Described math content" },
		{ key: "54", value: "54", text: "Accessible chemistry content (as LaTeX)" },
		{ key: "75", value: "75", text: "EAA exception 1 – Micro-enterprises" },
		{ key: "76", value: "76", text: "EAA exception 2 – Disproportionate burden" },
		{ key: "77", value: "77", text: "EAA exception 3 – Fundamental alteration" },
		{ key: "80", value: "80", text: "WCAG v2.0" },
		{ key: "81", value: "81", text: "WCAG v2.1" },
		{ key: "82", value: "82", text: "WCAG v2.2" },
		{ key: "84", value: "84", text: "WCAG level A" },
		{ key: "85", value: "85", text: "WCAG level AA" },
		{ key: "86", value: "86", text: "WCAG level AAA" },
		{ key: "90", value: "90", text: "Compliance certification by (name)" },
		{ key: "91", value: "91", text: "Latest accessibility assessment date" },
		{ key: "92", value: "92", text: "Accessibility addendum" },
		{ key: "93", value: "93", text: "Compliance certification by (URL)" },
		{ key: "94", value: "94", text: "Compliance web page for detailed accessibility information" },
		{ key: "95", value: "95", text: "Trusted intermediary’s web page for detailed accessibility information" },
		{ key: "96", value: "96", text: "Publisher’s web page for detailed accessibility information" },
		{ key: "97", value: "97", text: "Compatibility tested" },
		{ key: "98", value: "98", text: "Trusted Intermediary contact" },
		{ key: "99", value: "99", text: "Publisher contact for further accessibility information" },
	];
}
